(() => {
  if (window.summitCollectionBrandsInitialized) return;
  window.summitCollectionBrandsInitialized = true;

  document.addEventListener('change', (event) => {
    const selector = event.target;
    if (!(selector instanceof HTMLSelectElement) || !selector.matches('[data-collection-brand]')) return;

    const destination = new URL(selector.value, window.location.origin);
    const current = new URL(window.location.href);
    for (const [key, value] of current.searchParams) {
      if (key === 'sort_by' || (key.startsWith('filter.') && key !== 'filter.p.vendor')) {
        destination.searchParams.append(key, value);
      }
    }
    window.location.assign(destination.href);
  });
})();
